// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore, enableNetwork } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyBoc_OPSPsmQ77-lC1no8EMxnUXuUANbgY',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'lemur-476302.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'lemur-476302',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'lemur-476302.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '48418907254',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:48418907254:web:79e54038aebc2da35b6b57'
};

// Check if Firebase is properly configured
const isFirebaseConfigured = () => {
  // Check if we have valid Firebase config (either from env vars or fallbacks)
  const hasValidConfig = firebaseConfig.apiKey && 
                        firebaseConfig.projectId && 
                        firebaseConfig.appId &&
                        firebaseConfig.apiKey !== 'demo-api-key' &&
                        firebaseConfig.projectId !== 'demo-project' &&
                        firebaseConfig.appId !== 'demo-app-id';
  
  return hasValidConfig;
};

// Initialize Firebase only if properly configured
let app: any = null;
let db: any = null;
let auth: any = null;
let storage: any = null;
let functions: any = null;
let messaging: any = null;

if (isFirebaseConfigured()) {
  try {
    app = initializeApp(firebaseConfig);
    
    // IMPORTANT: Initialize auth FIRST, before Firestore
    // This ensures authentication context is available to Firestore
    auth = getAuth(app);
    
    // Browser: long-polling avoids "client is offline" when WebChannel is blocked (VPN/proxy/Windows).
    // SSR/tests: plain getFirestore.
    if (typeof window !== 'undefined') {
      try {
        db = initializeFirestore(app, {
          experimentalForceLongPolling: true,
        });
      } catch {
        db = getFirestore(app);
      }
      enableNetwork(db).catch((err) =>
        console.warn('[Firestore] enableNetwork:', err)
      );
    } else {
      db = getFirestore(app);
    }
    
    storage = getStorage(app);
    
    // Initialize Functions
    functions = getFunctions(app, 'us-central1');
    
    // Initialize Messaging (only in browser environment and if service worker is supported)
    if (typeof window !== 'undefined') {
      isSupported().then((supported) => {
        if (supported) {
          messaging = getMessaging(app);
        }
      }).catch(() => {
        // Messaging not supported (e.g., in Node.js environment)
      });
    }
  } catch (error) {
    console.error('❌ Firebase initialization failed:', error);
  }
}

export { db, auth, storage, functions, messaging, isFirebaseConfigured };
export default app;
